import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";
import { useEffect } from "react";

export function useTextReplacement(autocheck: WidgetAutocheck) {
  useEffect(() => {
    if (
      !autocheck.conversion.enabled ||
      !autocheck.conversion.splitStorefrontFeatures?.textEdits
    ) {
      return;
    }

    const textEdits = autocheck.conversion.splitStorefrontFeatures.textEdits;

    if (textEdits.length === 0) {
      return;
    }

    for (const textEdit of textEdits) {
      const elements = document.querySelectorAll(textEdit.selector);

      for (const element of elements) {
        if (element.textContent) {
          element.textContent = element.textContent.replace(
            textEdit.textToReplace,
            textEdit.replacementText,
          );
        }
      }
    }
  }, [autocheck]);
}
